/**
 * Shared helpers for environment files — single place for password-reset path logic.
 * Do not put secrets here.
 */

/** SPA route used after Supabase recovery email (must match backend PASSWORD_RESET_REDIRECT_URL path). */
export const PASSWORD_RESET_PATH = '/reset-password';

/**
 * Builds full password-reset URL from the deployed SPA origin (no trailing slash).
 * @param appOrigin e.g. https://app.example.com or http://localhost:4200
 */
export function buildPasswordResetUrl(appOrigin: string): string {
  const o = appOrigin.trim().replace(/\/$/, '');
  return o ? `${o}${PASSWORD_RESET_PATH}` : '';
}
